// ExcelEnviosRecepciones.js
import * as XLSX from 'xlsx-js-style';

/**
 * Función para exportar los datos de envíos y recepciones a un archivo Excel.
 * @param {Object} data - Objeto que contiene labels, enviosData y recepcionesData.
 * @param {string} groupBy - El tipo de agrupación actual ('day', 'week', 'month').
 */
const exportarEnviosRecepcionesAExcel = ({ labels, enviosData, recepcionesData, groupBy }) => {
    const wsData = [];
    const fileName = `Reporte_Envios_Recepciones_${groupBy}.xlsx`;
    let sheetName = 'Datos';

    // Determinar el título de la columna de la fecha/grupo
    let dateColumnTitle = 'Fecha';
    switch (groupBy) {
        case 'week':
            dateColumnTitle = 'Semana (YYYYWW)';
            sheetName = 'Por Semana';
            break;
        case 'month':
            dateColumnTitle = 'Mes (YYYY-MM)';
            sheetName = 'Por Mes';
            break;
        case 'day':
        default:
            dateColumnTitle = 'Día (YYYY-MM-DD)';
            sheetName = 'Por Día';
            break;
    }

    // Cabecera de la tabla
    wsData.push([dateColumnTitle, 'Cantidad de Envíos', 'Cantidad de Recepciones']);

    // Añadir los datos
    labels.forEach((label, index) => {
        wsData.push([
            label,
            enviosData[index] || 0,
            recepcionesData[index] || 0
        ]);
    });

    // Crear la hoja de trabajo
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Ajustar el ancho de las columnas automáticamente
    const colWidths = [
        { wch: dateColumnTitle.length + 2 }, // Ancho para la columna de fecha
        { wch: 'Cantidad de Envíos'.length + 2 },
        { wch: 'Cantidad de Recepciones'.length + 2 }
    ];
    ws['!cols'] = colWidths;

    // Aplicar estilos a la cabecera (negrita y bordes)
    const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    ['A1', 'B1', 'C1'].forEach(cellRef => {
        if (!ws[cellRef]) ws[cellRef] = {}; // Asegura que la celda exista
        ws[cellRef].s = headerStyle;
    });

    // Aplicar bordes delgados a todas las celdas de datos
    for (let row = 1; row < wsData.length; row++) {
        ['A', 'B', 'C'].forEach(colChar => {
            const cellRef = `${colChar}${row + 1}`; // +1 porque Excel es 1-indexado
            if (!ws[cellRef]) ws[cellRef] = {};
            ws[cellRef].s = {
                border: {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                }
            };
        });
    }


    // Crear un libro de trabajo y agregar la hoja
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Generar el archivo Excel y disparar la descarga
    XLSX.writeFile(wb, fileName);
};

export default exportarEnviosRecepcionesAExcel;